import React, {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {
  reduxSetPresetDateRange,
  reduxSetCustomDateRange,
} from 'appredux/actions';
import {RootState} from 'appredux/reducers';
import {
  PresetRange,
  presetRangeLabels,
} from 'appredux/reducers/reducer-date-filter';

import {Menu, MenuItem, Divider} from '@material-ui/core';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import moment from 'moment';

// …imports unchanged…

export default function DateRangeSelector() {
  const {preset, start, end} = useSelector((s: RootState) => s.rdwDateFilter);
  const dispatch = useDispatch();

  const [anchor, setAnchor] = useState<HTMLElement | null>(null);

  const choosePreset = (p: PresetRange) => {
    dispatch(reduxSetPresetDateRange(p));
    setAnchor(null);
  };

  return (
    <>
      {/* button inherits 34 px font from parent via CSS */}
      <button className="date-btn" onClick={(e) => setAnchor(e.currentTarget)}>
        {presetRangeLabels[preset]} ▾
      </button>

      {/* dropdown menu (unchanged) */}
      <Menu anchorEl={anchor} open={!!anchor} onClose={() => setAnchor(null)}>
        {Object.entries(presetRangeLabels).map(([key, label]) => (
          <MenuItem key={key} onClick={() => choosePreset(key as PresetRange)}>
            {label}
          </MenuItem>
        ))}

        <Divider style={{margin: '4px 0'}} />

        <MuiPickersUtilsProvider utils={MomentUtils}>
          <div style={{padding: 12}}>
            <KeyboardDatePicker
              variant="inline"
              autoOk
              format="DD/MM/yyyy"
              margin="normal"
              label="Start"
              value={moment(start)}
              onChange={(d) =>
                d && dispatch(reduxSetCustomDateRange(d.toDate(), end))
              }
            />
            <KeyboardDatePicker
              variant="inline"
              autoOk
              format="DD/MM/yyyy"
              margin="normal"
              label="End"
              value={moment(end)}
              onChange={(d) =>
                d && dispatch(reduxSetCustomDateRange(start, d.toDate()))
              }
            />
          </div>
        </MuiPickersUtilsProvider>
      </Menu>
    </>
  );
}
